import React, { useState } from "react";
import { Download, ShoppingCart } from "lucide-react";
import BizumModal from "@/components/BizumModal";
import { useAuth } from "@/context/AuthContext";

export function VersionActions({ track, version: v, config, compact }) {
  const [open, setOpen] = useState(false);
  const auth = useAuth();
  const paid = (v.price || 0) > 0;
  const isPista = !!(track.is_pista && !track.track_id);
  const item = isPista ? { ...track, version_title: v.version_id ? v.title : null } : { id: track.id, title: track.title, artist: track.artist, version_title: v.version_id ? v.title : null, price: v.price, cover_path: track.cover_path, version_id: v.version_id };
  return (
    <>
      <span data-testid={`version-price-${v.id}`}
        className={`shrink-0 flex items-center ${compact ? "px-2 text-[9px]" : "px-2.5 py-1 text-[10px]"} font-mono uppercase tracking-widest rounded-full border ${
          paid ? "bg-red-600/25 text-red-400 border-red-600/40" : "bg-emerald-500/20 text-emerald-400 border-emerald-500/30"}`}>
        {paid ? `€${Number(v.price).toFixed(2)}` : "Free"}
      </span>
      {paid ? (
        <button onClick={(e) => { e.stopPropagation(); setOpen(true); }} data-testid={`version-buy-${v.id}`} title="Comprar con PayPal"
          className={`${compact ? "p-1" : "p-2"} rounded-lg text-white/60 hover:text-red-500 hover:bg-red-600/10 shrink-0`}><ShoppingCart className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} /></button>
      ) : (
        <a href={v.download_url} onClick={(e) => { e.stopPropagation(); auth.requireAuth(e); }} data-testid={`version-download-${v.id}`} title="Descargar"
          className={`${compact ? "p-1" : "p-2"} rounded-lg text-white/60 hover:text-red-500 hover:bg-red-600/10 shrink-0`}><Download className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} /></a>
      )}
      <BizumModal open={open} onClose={() => setOpen(false)} item={item} itemType={isPista ? "pista" : "track"} config={config} />
    </>
  );
}
